import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample } from 'effector'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { model as moviesModel } from '~/entities/movies'
import { init, initRecommendedVodsPage } from '../root/model'
import { leftRegularSearchPage } from '../shared/regularSearchPageState'
import { resetSearchOnProfileSwitch } from '../shared/resetOnProfileSwitch'
import '../shared/searchField'

// Events

export const left = createEvent()

sample({
  clock: left,
  target: leftRegularSearchPage,
})

const $recommendedVodsTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('recommended')
)

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

sample({
  clock: init,
  target: initRecommendedVodsPage,
})

/********** Skeleton logics starts ***********/
sample({
  clock: api.vods.loadRealRecommendedVodsFx.pending, // TODO should be attach
  target: setContentLoading,
})
/********** Skeleton logics ends ***********/

sample({
  clock: resetSearchOnProfileSwitch,
  fn: () => false,
  target: setContentLoading,
})

register($recommendedVodsTitle, '$search/recommendedVodsTitle')
register(moviesModel.$formattedRecommendedVods, '$search/recommendedVods')
